"use client"

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import useSWR from 'swr'
import storage from '@utils/localStorage'
import { post } from '@api/apiFetcher'
import { USER_WATCHED_OFFERS } from '@constants/routes'
import { notify } from 'lib/notice/notice'
import { WATCH_LIMIT } from 'lib/watch/limits'
import { readGuest, removeGuestMany } from 'lib/watch/guestWatch'
import { refreshWatched } from 'lib/watch/watchStore'

const MERGE_API = '/api/user/watched/merge'
const LOCK = 'spl:obserwowane-dolaczanie'
const RETRY_MS = [5000, 30000]
const plural = (n, a, b, c) => { const t = n % 10, h = n % 100; return n === 1 ? a : (t >= 2 && t <= 4 && (h < 12 || h > 14)) ? b : c }

// Jedna karta naraz (Web Locks); bez nich — zapasowo bez blokady (serwer i tak nie doda drugi raz).
function withLock (fn) {
    return navigator.locks?.request ? navigator.locks.request(LOCK, fn) : fn()
}

export function mergeText ({ added, overLimit }) {
    const parts = []
    if (added > 0) parts.push(`Dodaliśmy ${added} ${plural(added, 'ogłoszenie', 'ogłoszenia', 'ogłoszeń')} do Twoich obserwowanych.`)
    if (overLimit > 0) parts.push(`${overLimit} ${plural(overLimit, 'nie zmieściło się', 'nie zmieściły się', 'nie zmieściło się')} — limit to ${WATCH_LIMIT} obserwowanych.`)
    return parts.join(' ')
}

// Po zalogowaniu (hasło, Google, Facebook, dokończenie rejestracji, logowanie po aktywacji) lista obserwowanych gościa
// z tej przeglądarki dołącza do konta; potem jest czyszczona. Na stronach logowania czeka na stronę docelową
// (komunikat nie znika przy przekierowaniu). Po błędzie sieci lista zostaje: ponowienie po 5 s i 30 s, potem przy
// następnym wejściu.
export default function GuestWatchMerge () {
    const { data: user } = useSWR('user', storage)
    const token = user?.token || null
    const path = usePathname() || ''
    const transit = path.startsWith('/konto/')

    useEffect(() => {
        if (!token || transit || !readGuest().length) return
        let stop = false
        let timer = null
        const attempt = async (n) => {
            try {
                const res = await withLock(async () => {
                    const list = readGuest()
                    if (!list.length || stop) return null
                    const r = await post({ path: MERGE_API, data: { items: list.map(({ id, at }) => ({ id, at })) }, auth: token }).catch(() => null)
                    if (typeof r?.added !== 'number') throw new Error('merge')
                    removeGuestMany(list.map(x => x.id))
                    return r
                })
                if (!res) return
                if (res.added > 0) refreshWatched()
                const text = mergeText(res)
                if (text) notify(text, { action: { label: 'Zobacz', name: 'Zobacz obserwowane ogłoszenia', href: USER_WATCHED_OFFERS } })
            } catch (err) {
                if (!stop && n < RETRY_MS.length) timer = setTimeout(() => attempt(n + 1), RETRY_MS[n])
            }
        }
        attempt(0)
        return () => { stop = true; clearTimeout(timer) }
    }, [token, transit])

    return null
}
